import { localize } from 'helpers/router';

export const REFERRAL_ANONYMOUS = localize('/referral-program');
export const REFERRAL_AUTHENTICATED = '/invite';
